(() => {
 if (window.ddBannersInitialized) return;
 window.ddBannersInitialized = true;
 function syncHeader() {
  const slide = document.querySelector('[data-dd-banner] [data-dd-slide]:not([hidden])');
  document.documentElement.dataset.ddBrand = slide?.dataset.ddBrand || document.documentElement.dataset.ddPageBrand || 'tailland';
  document.querySelectorAll('[data-dd-brand-products]').forEach(panel => {
   const active = panel.dataset.ddBrandProducts === document.documentElement.dataset.ddBrand;
   panel.hidden = !active;
   if (active) panel.querySelectorAll('.dd-reveal-ready').forEach(card => card.classList.add('dd-visible'));
  });
  document.querySelectorAll('.dd-navigation.dd-header').forEach(header => {
   if (slide) header.style.setProperty('--dd-header-color', slide.style.getPropertyValue('--slide-color'));
   else header.style.removeProperty('--dd-header-color');
  });
 }
 function initialize() {
  document.querySelectorAll('[data-dd-banner]').forEach(banner => {
   if (banner.dataset.ready) return;
   banner.dataset.ready = 'true';
   const slides = [...banner.querySelectorAll('[data-dd-slide]')];
   const buttons = [...banner.querySelectorAll('[data-dd-slide-to]')];
   if (!slides.length) return;
   let current = 0;
   function show(index) {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== current; });
    buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
    syncHeader();
   }
   banner.addEventListener('click', event => {
    const target = event.target.closest('[data-dd-slide-to]');
    if (target) show(Number(target.dataset.ddSlideTo));
    if (event.target.closest('[data-dd-next]')) show(current + 1);
    if (event.target.closest('[data-dd-prev]')) show(current - 1);
   });
   buttons.forEach(button => button.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    show(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
    buttons[current].focus();
   }));
   document.addEventListener('shopify:block:select', event => {
    const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
    if (index >= 0) show(index);
   });
  });
  syncHeader();
 }
 initialize();
 document.addEventListener('shopify:section:load', initialize);
 document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncHeader));
})();
